"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FlagDismissSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13.5,4 C13.7761424,4 14,4.22385763 14,4.5 C14,4.60848656 13.9654492,4.70890335 13.9067512,4.79084693 L12.1009252,7.5 L13.1,9 L11.899,9 L10.8990748,7.5 L12.5657415,5 L6,5 L6,10 L9,9.999 L9,11 L6,11 L6,15 L5,15 L5,4 L13.5,4 Z M10.7843055,10.0885912 L10.8535534,10.1464466 L12.5,11.793 L14.1464466,10.1464466 C14.3417088,9.95118446 14.6582912,9.95118446 14.8535534,10.1464466 C15.0271197,10.320013 15.0464049,10.5894374 14.9114088,10.7843055 L14.8535534,10.8535534 L13.207,12.5 L14.8535534,14.1464466 C15.0488155,14.3417088 15.0488155,14.6582912 14.8535534,14.8535534 C14.679987,15.0271197 14.4105626,15.0464049 14.2156945,14.9114088 L14.1464466,14.8535534 L12.5,13.207 L10.8535534,14.8535534 C10.6582912,15.0488155 10.3417088,15.0488155 10.1464466,14.8535534 C9.97288026,14.679987 9.95359511,14.4105626 10.0885912,14.2156945 L10.1464466,14.1464466 L11.793,12.5 L10.1464466,10.8535534 C9.95118446,10.6582912 9.95118446,10.3417088 10.1464466,10.1464466 C10.320013,9.97288026 10.5894374,9.95359511 10.7843055,10.0885912 Z" })));
};
FlagDismissSmall.displayName = 'FlagDismissSmall';
exports.default = FlagDismissSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FlagDismissSmall.js.map